import { RequestMethod } from "@/shared/utils/RequestMethod";
import { api, BASE_URL } from "../app.api";

type UploadParams = {
  file: File;
  field: {
    user_id: number;
    anonymous: boolean;
  };
  emdPoin?: string; // Opcional si lo necesitas dinámico
};

export const uploadFile = async ({ file, field, emdPoin }: UploadParams) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("user_id", String(field.user_id));

    const response = await fetch(
      `${BASE_URL}${emdPoin || "/admin/progress-image/create"}`,
      {
        method: "POST",
        body: formData,
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData?.message || "Error al subir el archivo");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Upload error:", error);
    throw error;
  }
};

const ProgressImageApi = api
  .enhanceEndpoints({ addTagTypes: ["progress-image"] })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      progressImage: builder.query({
        query: ({ id }: any) => ({
          url: `admin/progress-image/all/${id}`,
          method: RequestMethod.GET,
        }),
        transformResponse: (response: any) => response,
      }),

      deleteProgressImage: builder.mutation({
        query: ({ id, image_id }: any) => ({
          url: `admin/progress-image/delete/${id}/${image_id}`,
          method: RequestMethod.POST,
        }),
      }),

      // medical report

      //admin/medical-report/all/288

      medicalReport: builder.query({
        query: ({ id }: any) => ({
          url: `admin/medical-report/all/${id}`,
          method: RequestMethod.GET,
        }),
      }),

      //admin/medical-report/delete/{user_id}/{id}
      deleteMedicalReport: builder.mutation({
        query: ({ id, item_id }: any) => ({
          url: `admin/medical-report/delete/${id}/${item_id}`,
          method: RequestMethod.POST,
        }),
      }),
    }),
  });

export const { useProgressImageQuery, useDeleteProgressImageMutation , useMedicalReportQuery, useDeleteMedicalReportMutation } =
  ProgressImageApi;
